var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartTreeMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M304 192c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zM48 272c-26.5 0-48 21.5-48 48v112c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48z",
  style: {
    opacity: 0.4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 80c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm256 0c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48zm48 272h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48",
  className: "chart-tree-map_svg__fa-primary"
})));
export default SvgChartTreeMap;